<template>
  <transition-group name='fade'>
    <!-- 遮罩层 -->
    <div class="mask"
         key="1"
         @click="show = false"
         v-if="show"
         @touchmove.prevent>
    </div>
    <!-- 弹窗 -->
    <div class="pop"
         v-show="show"
         key="2">
      <div class="pop-header por clearfix">
        <p class="fs20 pop-header-title">有问题，请联系我们</p>
        <div class="pop-close-btn poa "
             @click="show = false">
          <img src="@/assets/images/popup/close.png"
               alt="">
        </div>
      </div>
      <div class="pop-main flex">
        <div class="pop-main-left por">
          <div class="pop-main-left-img poa">
            <img :src="kfInfo.customer_code" alt="">
          </div>
          <div class="fs18 pop-main-left-title">微信扫码，添加<span class=""
                  style="color:#1177FF">客服</span></div>
          <div>联系电话<span class="ml15 ftcolor">19303035318</span>
          </div>
          <div class="flex mt10">上班时间<span class="time-box ml15 ftcolor">周一至周五 9:00~12:00 13:00~18:00</span>
          </div>
        </div>
        <div class="pop-main-right por">
          <div class="pop-main-right-img poa">
            <img :src="kfInfo.wx_code" alt="">
          </div>
          <div class="fs18 pop-main-right-title">微信扫码，关注<span class=""
                  style="color:#1177FF">公众号</span></div>
          <div style="width:182px;color:#999FA6;margin-top:28px">在公众号内直接回复您遇到的问题，我们会及时为您解答。</div>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "Popup",
  data () {
    return {
      show: false,
    }
  },
  computed: {
    ...mapGetters(['kfInfo']),
  },
  methods: {
    btnClick () {
      this.show = false
    },
  },
  created () {},
}
</script>

<style lang="less" scoped>
.ftcolor{
  color: #333F4E;
}
// 渐变过渡
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s;
}
// 全局弹窗
.mask {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  z-index: 998;
  width: 100vw;
  height: 100vh;
}

.pop {
  height: 456px;
  width: 744px;
  background: #fff;
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  overflow: hidden;
  .pop-header {
    width: 100%;
    height: 132px;
    color: #fff;
    font-size: 20px;
    text-align: center;
    background: url(../../assets/images/popup/bg.png) no-repeat;
    .pop-header-title{
      margin-top: 35px;
      font-weight: bold;
    }
    .pop-close-btn {
      right: 9px;
      top: 9px;
      width: 28px;
      height: 28px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .pop-main {
    width: 100%;
    height: 324px;
    .pop-main-left {
      width: 50%;
      height: 100%;
      padding-top: 135px;
      padding-left: 101px;
      color: #999fa6;
      .pop-main-left-img {
        top: -34px;
        left: 137px;
        width: 142px;
        height: 142px;
        box-shadow: 0px 5px 11px 0px rgba(0, 15, 34, 0.08);
        z-index: 1000;
        img{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .pop-main-left-title {
        margin-left: 27px;
        margin-bottom: 28px;
        color: #666f7a;
      }
      .time-box {
        display: inline-block;
        width: 149px;
      }
      div {
        font {
          color: #333f4e;
          margin-left: 14px !important;
        }
      }
    }
    .pop-main-right {
      width: 50%;
      height: 100%;
      padding-top: 135px;
      padding-left: 78px;
      .pop-main-right-img {
        top: -34px;
        right: 137px;
        width: 142px;
        height: 142px;
        z-index: 1000;
        box-shadow: 0px 5px 11px 0px rgba(0, 15, 34, 0.08);
        img{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .pop-main-right-title{
        color: #666f7a;
      }
    }
  }
}
</style>